import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private url = environment.championsProdUrl;
  constructor(private http: HttpClient) { }

  login(username: string, password: String): Observable<any> {
    return this.http.post(`${this.url}/auth/token`, { username: username, password: password }, {
      headers: { 'Content-Type': 'application/json' }
    })
  }

  resetPassword(oldPassword: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.url}/api/user/reset-password`, { currentPassword: oldPassword, newPassword: newPassword })
  }

  requestOtp(customerId: number): Observable<any> {
    return this.http.post(`${this.url}/api/otp/request`, { customerId: customerId })
  }

  validateOtp(customerId: number, otpValue: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.url}/api/otp/validate`, { customerId: customerId, value: otpValue, newPassword: newPassword })
  }

  testDatabaseConnection(): Observable<any> {
    return this.http.post(`${this.url}/api/health`, {}, {
      headers: { 'Content-Type': 'application/json' }
    })
  }
}
